// Identifierar trafik som kommer från AI-assistenter och generativa sökytor.
// Används för att kunna mäta bokningar och leads från AI-hänvisningar separat
// (se docs/search-ai-experience/04-matning-och-kpi.md).

const AI_REFERRER_PATTERNS: Array<{ pattern: RegExp; surface: string }> = [
  { pattern: /(^|\.)chatgpt\.com$/i, surface: "chatgpt" },
  { pattern: /(^|\.)chat\.openai\.com$/i, surface: "chatgpt" },
  { pattern: /(^|\.)openai\.com$/i, surface: "openai" },
  { pattern: /(^|\.)perplexity\.ai$/i, surface: "perplexity" },
  { pattern: /(^|\.)gemini\.google\.com$/i, surface: "gemini" },
  { pattern: /(^|\.)bard\.google\.com$/i, surface: "gemini" },
  { pattern: /(^|\.)claude\.ai$/i, surface: "claude" },
  { pattern: /(^|\.)copilot\.microsoft\.com$/i, surface: "copilot" },
  { pattern: /(^|\.)bing\.com$/i, surface: "bing" },
  { pattern: /(^|\.)you\.com$/i, surface: "you" },
  { pattern: /(^|\.)phind\.com$/i, surface: "phind" },
  { pattern: /(^|\.)poe\.com$/i, surface: "poe" },
  { pattern: /(^|\.)mistral\.ai$/i, surface: "mistral" },
  { pattern: /(^|\.)grok\.com$/i, surface: "grok" },
  { pattern: /(^|\.)x\.ai$/i, surface: "grok" },
];

/** Returnerar AI-ytans namn om värden är en känd AI-assistent, annars null. */
export function aiSurfaceFromHost(host: string | null | undefined): string | null {
  if (!host) return null;
  const clean = host.replace(/^www\./i, "");
  for (const { pattern, surface } of AI_REFERRER_PATTERNS) {
    if (pattern.test(clean)) return surface;
  }
  return null;
}

/**
 * Bing är både klassisk sök och AI-yta (Copilot). Vi räknar bara bing som
 * AI-hänvisning när landningen bär en AI-parameter, annars som organiskt.
 */
export function isAmbiguousAiSurface(surface: string | null): boolean {
  return surface === "bing";
}

export const AI_REFERRAL_MEDIUM = "ai_referral";
